import React from "react";
import { Login } from "elentari";
import logo from "../../images/logo-avaliare.png";
import { login, setToken } from "../../services/Api";

export default function CustomLogin({ history }) {
  const handleLogin = async ({ username, password }) => {
    const response = await login({
      email: username,
      password,
    });
    if (response.ok) {
      setToken(response.data.token);
      return {
        ok: true,
        token: response.data.token,
        name: username,
      };
    }
  };

  return (
    <Login
      history={history}
      onSubmit={handleLogin}
      requiredLabel="Obrigatório"
      usernameLabel="Usuário"
      submitLabel="Entrar"
      passwordLabel="Senha"
      recoverPasswordLabel="Recuperar Senha"
      logo={<img alt="logo" width="175px" src={logo} />}
    />
  );
}
